import styled from "styled-components"
import GridContainer from "@/components/common/GridContainer"
import { getAspectRatio, getCssSizeValue, getPaddingsClassFromData } from "@/utils/utils"
import Image, { formatImageCMSData } from "@/components/common/Image"
import { BREAKPOINTS } from "@/styles/themeSettings"
import HeaderDescriptionBlock from "@/components/HeaderDescriptionBlock"

const VARIANTS = {
	DEFAULT: "default",
	FULL_SCREEN: "full_screen",
	SMALL: "small",
}

const StyledImageWrapper = styled.div`
	width: 100%;
	margin-bottom: ${getCssSizeValue(24, BREAKPOINTS.MOBILE)};

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		margin-bottom: unset;
	}
`

const StyledImage = styled(Image)`
	aspect-ratio: ${({ $aspectRatio }) => $aspectRatio || "16/9"};
	width: 100%;
	height: auto;
`

export default function TwoImagesInRowModule({ data }) {
	const paddings = getPaddingsClassFromData(data)
	const variant = data?.variant || ""

	const {
		url: leftImageUrl,
		alt: leftImageAlt,
		width: leftImageWidth,
		height: leftImageHeight,
	} = formatImageCMSData(data?.leftImage?.image || {})

	const {
		url: rightImageUrl,
		alt: rightImageAlt,
		width: rightImageWidth,
		height: rightImageHeight,
	} = formatImageCMSData(data?.rightImage?.image || {})

	const leftImageAspectRatio = getAspectRatio(leftImageWidth, leftImageHeight)
	const rightImageAspectRatio = getAspectRatio(rightImageWidth, rightImageHeight)

	const { desktopCols, indent } = {
		indent: variant === VARIANTS.DEFAULT ? 1 : variant === VARIANTS.SMALL ? 3 : "",
		desktopCols: variant === VARIANTS.DEFAULT ? 7 : variant === VARIANTS.SMALL ? 5 : 8,
	}

	const imageWrapperClassName = `col-desktop-${desktopCols} col-tablet-8 col-mobile-8`

	return (
		<div className={paddings}>
			<HeaderDescriptionBlock headerDescription={data?.headerDescription} />
			<GridContainer className={`indent-desktop-${indent} ${variant === VARIANTS.FULL_SCREEN ? "no-margin" : ""}`}>
				<StyledImageWrapper className={imageWrapperClassName}>
					<StyledImage src={leftImageUrl} alt={leftImageAlt} sizes={"100vw"} $aspectRatio={leftImageAspectRatio} />
				</StyledImageWrapper>
				<StyledImageWrapper className={imageWrapperClassName}>
					<StyledImage src={rightImageUrl} alt={rightImageAlt} sizes={"100vw"} $aspectRatio={rightImageAspectRatio} />
				</StyledImageWrapper>
			</GridContainer>
		</div>
	)
}
